import { t } from '@lingui/macro';
import { useState } from 'react';
import { branding } from './config';

export function BrandLogo({
  className,
  compact = false,
}: {
  className?: string;
  compact?: boolean;
}) {
  const [failed, setFailed] = useState(false);
  const name = branding.name || t({ id: 'branding.workspace', message: 'Workspace' });
  const src = compact ? branding.iconUrl : branding.logoUrl;
  if (src && !failed) {
    return <img src={src} alt={name} className={className} onError={() => setFailed(true)} />;
  }
  if (compact) {
    return (
      <span role='img' aria-label={name} className={className}>
        <span className='flex size-full items-center justify-center rounded-md bg-muted text-foreground font-semibold'>
          {name.charAt(0)}
        </span>
      </span>
    );
  }
  return (
    <span className={`inline-flex items-center text-foreground font-semibold ${className ?? ''}`}>
      {name}
    </span>
  );
}
